import { outter_post, outter_post_newUrl } from 'common/js/axios-helper';
import { MarketApi } from "./constant/UrlMapper";

const host = "8880";


const tatFakeProfitList = (data) => {
    return outter_post(MarketApi.TatFakeProfitList, data, host);
};

const tatFakeProfitAdd = (data) => {
    return outter_post(MarketApi.TatFakeProfitAdd, data, host);
};

const tatFakeProfitIsExist = (data) => {
    return outter_post(MarketApi.TatFakeProfitIsExist, data, host);
};

const TatIndexDataUpdate = (data) => {
    return outter_post(MarketApi.TatIndexDataUpdate, data, host);
};

const TatIndexDataDetail = (data) => {
    return outter_post(MarketApi.TatIndexDataDetail, data, host);
};

const tatPublicPlatoonAdd = (data) => {
    return outter_post(MarketApi.TatPublicPlatoonAdd, data, host);
};

const tatPublicPlatoonEdit = (data) => {
    return outter_post(MarketApi.TatPublicPlatoonEdit, data, host);
};

const tatPublicPlatoonUdp = (data) => {
    return outter_post(MarketApi.TatPublicPlatoonUdp, data, host);
};

const tatPublicPlatoonDel = (data) => {
    return outter_post(MarketApi.TatPublicPlatoonDel, data, host);
};

const tatPublicPlatoonList = (data) => {
    return outter_post(MarketApi.TatPublicPlatoonList, data, host);
};

const detailForLineName = (data) => {
    return outter_post(MarketApi.DetailForLineName, data, host);
};

const tatPublicPlatoonPeople = (data) => {
    return outter_post(MarketApi.TatPublicPlatoonPeople, data, host);
};


const tatPublicPreLicensing = (data) => {
    return outter_post(MarketApi.TatPublicPreLicensing, data, host);
};

const tatPublicPreLicensingNew = (data) => {
    return outter_post_newUrl(MarketApi.PublicPreListByPage, data, '8889');
};

const licenReissue = (data) => {
    return outter_post(MarketApi.LicenReissue, data, host);
};

const sumMoney = (data) => {
    return outter_post(MarketApi.SumMoney, data, host);
};

const memLevelPublicPlatoonList = (data) => {
    return outter_post(MarketApi.MemLevelPublicPlatoonList, data, host);
};

const memLevelPublicPlatoonPeople = (data) => {
    return outter_post(MarketApi.MemLevelPublicPlatoonPeople, data, host);
};

const memLevelPublicPlatoonLicensing = (data) => {
    return outter_post(MarketApi.MemLevelPublicPlatoonLicensing, data, host);
};
const memLevelPublicPlatoonEdit = (data) => {
    return outter_post(MarketApi.MemLevelPublicPlatoonEdit, data, host);
};
const levelPublicPeople = (data) => {
    return outter_post(MarketApi.LevelPublicPeople, data, host);
};

const twopublicplatoonList = (data) => {
    return outter_post(MarketApi.TwoPublicPlatoonList, data, host);
};

const dandeliondotsortList = (data) => {
    return outter_post(MarketApi.DandelionDotsortList, data, host);
};

const memberselecttwoList = (data) => {
    return outter_post(MarketApi.MemberselecttwoList, data, "8883");
};

export default {
    tatFakeProfitList,
    tatFakeProfitAdd,
    TatIndexDataUpdate,
    TatIndexDataDetail,
    tatFakeProfitIsExist,
    tatPublicPlatoonAdd,
    tatPublicPlatoonEdit,
    tatPublicPlatoonUdp,
    tatPublicPlatoonDel,
    tatPublicPlatoonList,
    detailForLineName,
    tatPublicPlatoonPeople,
    tatPublicPreLicensing,
    tatPublicPreLicensingNew,
    licenReissue,
    sumMoney,
    memLevelPublicPlatoonList,
    memLevelPublicPlatoonPeople,
    memLevelPublicPlatoonLicensing,
    memLevelPublicPlatoonEdit,
    levelPublicPeople,

    twopublicplatoonList,
    dandeliondotsortList,

    memberselecttwoList,
}



// WEBPACK FOOTER //
// ./src/service/MarketService.js